<div class="modal fade" [id]="id" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    [attr.aria-labelledby]="id + 'Label'" aria-hidden="true" data-bs-focus="false">
    <div class="modal-dialog" [style.max-width.px]="modalWidth">
        <div class="modal-content">
            <div class="modal-header hidden-print">
                <i *ngIf="route" class="bi bi-box-arrow-up-right me-2" role="button" (click)="openNewBrowserTab()"></i>
                <h5 class="modal-title break-title" [id]="id + 'Label'" [style.max-width.px]="modalWidth - 100">{{title}}</h5>
                <button *ngIf="ajuda" type="button" class="btn-ajuda" (click)="go.navigate({route: ['suporte', 'ajuda', ajuda]})" data-bs-toggle="tooltip" data-bs-placement="top" title="Suporte do Módulo"><i class="bi bi-play-btn"></i></button>
                <button *ngIf="gb.isToolbar" type="button" class="btn-close btn-minimize" data-bs-dismiss="modal" aria-label="Minimize" (click)="minimize()"></button>
                <button type="button" class="btn-close" [class.btn-no-left-margin]="gb.isToolbar" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>            
            <div class="modal-body">                
                <document-preview *ngIf="html?.length" noMargin [html]="html"></document-preview>
                <ng-template #body></ng-template>
                <ng-container *ngIf="template" [ngTemplateOutlet]="template" [ngTemplateOutletContext]="templateContext"></ng-container>
                <div style="white-space: pre-wrap;">{{message}}</div>
            </div>
            <div *ngIf="buttons.length" class="modal-footer hidden-print">
                <button *ngFor="let button of buttons" type="button" [class.disabled]="isDisabled(button)" [class]="'btn ' + (button.color || 'btn-primary')" (click)="buttonClick(button)">
                    <i *ngIf="button.icon" [class]="button.icon"></i>
                    {{button.label}}
                </button>
            </div>
        </div>
    </div>
</div>